import { batch } from 'react-redux'
import { putCookie } from '@chilecompra/react-kit'
import { customizeError } from '@chilecompra/react-kit/errors'
import { USER_TYPES_DICTIONARY, USER_TYPES_TRANSLATION_DICTIONARY } from '../../config/settings/constants'
import { REACT_APP_ACCESS_TOKEN_NAME } from '../../config/settings/environment'
import { makeActionCreator } from '../../config/store/utils'
import { getCookieFromDomain } from '../../modules/cookies'
import { getAuthInfo } from '../../services/auth'

export const GET_TOKEN = 'GET_TOKEN'
export const GET_TOKEN_ERROR = 'GET_TOKEN_ERROR'
export const GET_TOKEN_SUCCESS = 'GET_TOKEN_SUCCESS'
export const onGetToken = makeActionCreator(GET_TOKEN)
export const onGetTokenError = makeActionCreator(GET_TOKEN_ERROR, 'payload')
export const onGetTokenSuccess = makeActionCreator(GET_TOKEN_SUCCESS, 'payload')
export const onGetTokenThunk = () => async dispatch => {
  dispatch(onGetToken())
  try {
    const accessToken = await Promise.resolve()
      .then(() => getCookieFromDomain(REACT_APP_ACCESS_TOKEN_NAME))
      .catch(() => {
        throw customizeError({ code: 400, reason: 'SOMETHING_WENT_WRONG_ERROR' })
      })

    putCookie('access_token', accessToken)

    return batch(() => {
      dispatch(onGetTokenSuccess({ accessToken }))
      dispatch(onGetAuthInfoThunk())
    })
  } catch (error) {
    const { reason } = error.toObject()
    return dispatch(onGetTokenError({ reason }))
  }
}

export const GET_AUTH_INFO = 'GET_AUTH_INFO'
export const GET_AUTH_INFO_ERROR = 'GET_AUTH_INFO_ERROR'
export const GET_AUTH_INFO_SUCCESS = 'GET_AUTH_INFO_SUCCESS'
export const onGetAuthInfo = makeActionCreator(GET_AUTH_INFO)
export const onGetAuthInfoError = makeActionCreator(GET_AUTH_INFO_ERROR, 'payload')
export const onGetAuthInfoSuccess = makeActionCreator(GET_AUTH_INFO_SUCCESS, 'payload')
export const onGetAuthInfoThunk = () => async dispatch => {
  dispatch(onGetAuthInfo())
  try {
    const { data } = await getAuthInfo()
    return dispatch(
      onGetAuthInfoSuccess({
        authInfo: {
          isBuyer: USER_TYPES_TRANSLATION_DICTIONARY[data?.payload?.tipoUsuario] === USER_TYPES_DICTIONARY.BUYER,
          isSeller: USER_TYPES_TRANSLATION_DICTIONARY[data?.payload?.tipoUsuario] === USER_TYPES_DICTIONARY.SELLER,
          orgCode: data?.payload?.codigoOrganismo || '',
          userCode: data?.payload?.codigoUsuario || '',
          userName: data?.payload?.name || data?.payload?.preferred_username,
          userType: data?.payload?.tipoUsuario || 'Publico',
          hasObserverRole: data?.payload?.roles.includes(53),
          orgTaxID: data?.payload?.rut || '',
          dni: data?.payload?.rut
        }
      })
    )
  } catch (error) {
    return dispatch(
      onGetAuthInfoError({
        error: {
          code: error.code,
          message: error.reason
        }
      })
    )
  }
}
